import React from "react";


const Questions = () => {
    return (
        <section className="questions-container">
            <div className="text">
                <p> PREGUNTAS<br></br> FRECUENTES </p>
            </div>
            <div className="questions">
                <p>¿EN QUÉ MERCADOS TRABAJAS <br></br> ACTUALMENTE?<br></br> Actualmente estamos bien posicionados para
                <br></br>atender a los clientes tanto en los mercados<br></br>emergentes como en los desarrollados.
                </p> 
                <p>¿CÓMO PUEDO SOLICITAR UNA CONSULTA Y<br></br>UNA DEMO?
                <br></br>Ofrecemos una consulta inicial gratuita a los<br></br>nuevos clientes, para entender mejor sus 
                <br></br>necesidades y explicar nuestros servicios.<br></br>Solo tiene que enviarnos un correo electrónico
                <br></br>para reservar tu sesión.
                </p>
            </div>
        </section>
    );
};

export default Questions;